<template>
  <div id="live_submenu">
    <b-button
      :class="[currentTab === 'style' ? 'active' : '']"
      class="inline-submenu-btn with_icon"
      @click="changeAdminTab('style')">
      <b-icon icon="list-ul" aria-hidden="true"></b-icon>
      Style</b-button>
    <b-button
      :class="[currentTab === 'parcours' ? 'active' : '']"
      class="inline-submenu-btn with_icon"
      @click="changeAdminTab('parcours')">
      <b-icon icon="geo" aria-hidden="true"></b-icon>
      Infos parcours</b-button>
  </div>
</template>

<script>
export default {
  props: ["currentTab"],
  data() {
    return {};
  },
  methods: {
    changeAdminTab(tab) {
      this.$emit("changeAdminTab", tab);
    },
  },
};
</script>

<style lang="sass" scoped>
</style>